<h1 matDialogTitle>Conferma</h1>
<div mat-dialog-content innerHTML="{{data.message}}"></div>
<div mat-dialog-actions class="pt-24" align="end">
    <button mat-button (click)="dialogRef.close(false)">No</button>
    <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">{{data.buttonLabel}}</button>
</div>
